<template>
	<b-modal v-model="show" :header="false" :footer="false" class="fade backdrop" @hide="close">
		<div slot="default">
			<div class="iadsa-modal-header">
				<b-btn class="close btn btn-head-modal" @click="show=false">
					<i class="material-icons">close</i>
				</b-btn>
			</div>
			<div class="iadsa-modal-body">
				<h5>Delete</h5>
				<h2>Are you sure?</h2>
				<p>
					You're about to delete:
					<br>
					<span class="medium blue">{{ details.name }}</span>
				</p>
				<div style="margin-top:30px">
					<b-btn class="btn btn-danger" @click="deleteItem(details.id)">
						<strong>DELETE</strong>
					</b-btn>
					<b-btn class="btn btn-default" @click="show=false">
						Cancel
					</b-btn>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<style lang="less" scoped>
	.btn {
		margin-right: 5px;
	}
</style>


<script>
export default {
	props: {
		showModal: {
			type: Boolean,
			required: true
		},
		details: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			show: false,
		};
	},
	watch: {
		showModal() {
			this.show = this.showModal;
		}
	},
	methods: {
		close() {
			this.$emit('closeDeleteModal');
		},
		deleteItem(id) {
			this.$emit('delete', id);
		}
	}
};
</script>
